const styles = {
  versionButton: {
    color: '#5236AB',
    fontWeight: 500,
    fontSize: '0.875rem',
    textTransform: 'none',
    backgroundColor: 'transparent',
    padding: '0 4px',
    minWidth: 'auto',
    height: '36px',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: '#3f2891',
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  popoverContent: {
    p: 2,
    minWidth: 400,
    maxWidth: 500,
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    py: 2,
  },
  releaseTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: '#5236AB',
    mb: 0,
  },
  releaseDate: {
    fontSize: '0.8125rem',
    color: '#666',
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.8125rem',
    color: '#5236AB',
    borderBottom: '2px solid #e0d8f6',
  },
  commitHash: {
    fontFamily: 'monospace',
    fontSize: '0.8125rem',
    cursor: 'default',
  },
  message: {
    fontSize: '0.875rem',
    color: '#666',
    py: 1,
  },
  errorMessage: {
    fontSize: '0.875rem',
    color: '#d32f2f',
    py: 1,
  },
};

export default styles;
